module.exports = __webpack_public_path__ + "img/bell-off.bc81ff68.svg";